import { BASE_API_URL } from '@env';
import { useQuery } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { IChild } from '~types/api/user';

export function useGetUserChildren() {
  return useQuery<IChild[], Error>(
    'userChildren', // Query key
    async () => {
      const token = useUserStore.getState().token;
      const response = await fetch(`${BASE_API_URL}user/children`, {
        method: 'GET',
        headers: {
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch user children');
      }

      const data = await response.json();

      return data as IChild[];
    },
  );
}
